export default function ABOUT() {
  const [w,d] = [window,document]
  w.addEventListener('DOMContentLoaded',()=>{
    // リストコンテナのクラス変更
    const list_container = d.querySelector('.element_list')
    const detail_container = d.querySelector('.element_detail')
    if(list_container){
      list_container.classList.remove('element_list')
      list_container.classList.add('p-about__list')
    }
    if(detail_container){
      detail_container.classList.remove('element_detail')
      detail_container.classList.add('p-about__detail')
    }
    $('.paginationbox').appendTo('#container')

  })
}